<template>
    <div class="charts charts--outer">

		<div class="charts__row">
			<div class="charts__item" v-for="(item,index) in getFirstWeeks" :key="index">
				<chart-week
					:indexWeek="item.index"
					:datePeriod="item.date"
					:switchModeIcon="switchIcon[index]"
					@switchMode="switchMode">
				</chart-week>
			</div>
		</div>

        <div class="charts__row">
			<div class="charts__item" v-for="(item,index) in getLastWeeks" :key="index">
				<chart-week
					:indexWeek="item.index"
					:datePeriod="item.date">
				</chart-week>
			</div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import SingleWeekChart from "./singleWeekChart";
export default {
    components: {
        'chart-week':SingleWeekChart
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:false}
    },
    data() {
        return {
            statistics:null,
            weekStat:null,
            switchIcon:[false, true]
        }
    },
    computed: {
        ...mapGetters({
              getMonthStat: 'accountstat/getYearStat',
        }),
        getFirstWeeks() {
            if(this.weekStat === null)
                return
            let firstWeeks = this.weekStat;
            return firstWeeks.slice(0,2);
        },
        getLastWeeks() {
            if(this.weekStat === null)
                return
            let lastWeeks = this.weekStat;
            return lastWeeks.slice(2);
        }
    },
    methods: {
        getStat() {
            let stat = this.getMonthStat();
            if(!stat.week || !stat || stat.week.length === 0)
                return
            this.statistics = stat;
            this.weekStat = getWeekIndex(this.statistics.week.slice(this.statistics.week.length - 4));
        },
        switchMode() {
            this.$emit('switchMode');
        }
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            this.getStat()
        });
        this.getStat();
    },
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "weekWidget-grid",
            handler: handler
        }
    });
}
function getWeekIndex(stat) {
    let index = [];
    for(let i = 0; i < stat.length; i++) {
        for (let j = 0; j < stat[i].length; j++) {
            if(stat[i][j].title)
                index.push({index:stat[i][j].title,date:stat[i][j-1].date});
        }
    }
    return index;
}
</script>
<style lang="less">

</style>
